class OrientationHandler {
	handle() {
		const viewport = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
		if (!viewport) return;
		const original = viewport.content;
		viewport.content = 'width=device-width, initial-scale=1, maximum-scale=1';
		setTimeout(() => {
			viewport.content = original;
		}, 500);
	}
}

export default new OrientationHandler();
